import classes from "./AdminExpenseUnitsPage.module.css";

interface EditExpenseUnitModalProps {
  isOpen: boolean;
  isEditMode: boolean;
  formData: { id: number; name: string };
  onClose: () => void;
  onSave: () => void;
  onInputChange: (field: "id" | "name", value: string | number) => void;
  validationErrors: { id?: string; name?: string };
}

const EditExpenseUnitModal = ({
  isOpen,
  isEditMode,
  formData,
  onClose,
  onSave,
  onInputChange,
  validationErrors,
}: EditExpenseUnitModalProps) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div
        className={classes.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.modalHeader}>
          {isEditMode ? "Muokkaa kustannuspaikkaa" : "Lisää uusi kustannuspaikka"}
        </div>
        <div className={classes.modalBody}>
          <div className={classes.inputGroup}>
            <label className={classes.inputLabel}>Kustannuspaikka</label>
            <input
              type="number"
              className={`${classes.input} ${validationErrors.id ? classes.inputError : ""}`}
              value={formData.id || ""}
              onChange={(e) => onInputChange("id", e.target.value)}
              disabled={isEditMode}
            />
            {validationErrors.id && (
              <span className={classes.errorText}>{validationErrors.id}</span>
            )}
          </div>
          <div className={classes.inputGroup}>
            <label className={classes.inputLabel}>Nimi</label>
            <input
              type="text"
              className={`${classes.input} ${validationErrors.name ? classes.inputError : ""}`}
              value={formData.name}
              onChange={(e) => onInputChange("name", e.target.value)}
            />
            {validationErrors.name && (
              <span className={classes.errorText}>{validationErrors.name}</span>
            )}
          </div>
        </div>
        <div className={classes.modalFooter}>
          <button className={classes.cancelButton} onClick={onClose}>
            Peruuta
          </button>
          <button className={classes.saveButton} onClick={onSave}>
            Tallenna
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditExpenseUnitModal;
